import { ConditionReport } from "@skinsoft/types"
import { conditionReportSelectors } from "@skinsoft/selectors"
import { OfflineDataFetcher } from "../offline-data-fetcher"
import { matchesRegex } from "@skinsoft/utils"

export class ConditionReportOfflineDataFetcher extends OfflineDataFetcher<ConditionReport> {

    constructor(cacheKey: string) {
        super(cacheKey)
    }

    protected async queryTextFilter(entity: ConditionReport, queryText: string, locale: string): Promise<boolean> {
        const lowerCaseQueryText: string = queryText.toLowerCase()

        const isWemi: boolean = "item" in entity && "manifestation" in entity && "expression" in entity && "work" in entity

        let titleMatch: boolean
        let identifierMatch: boolean
        
        // report title match 
        const title: string = conditionReportSelectors.title(entity, locale)
        titleMatch = title ? matchesRegex(lowerCaseQueryText, title.toLowerCase()) : false

        // report identifier match
        const identifier: string = conditionReportSelectors.referenceNumber(entity)
        identifierMatch = identifier ? matchesRegex(lowerCaseQueryText, identifier.toLowerCase()) : false

        return titleMatch || identifierMatch
    }
}